package com.trevorwiebe.timesheet.calendar.presentation.composables

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Text
import androidx.compose.material3.MaterialTheme
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.trevorwiebe.timesheet.theme.successGreenBackground
import com.trevorwiebe.timesheet.theme.successGreenText

@Composable
fun DayBlockEventItem(
    employeeName: String,
    approved: Boolean?,
) {

    val backgroundColor = if (approved == true) successGreenBackground else if(approved == false) MaterialTheme.colorScheme.errorContainer else MaterialTheme.colorScheme.background
    val textColor = if (approved == true) successGreenText else if (approved == false) MaterialTheme.colorScheme.onErrorContainer else MaterialTheme.colorScheme.onBackground

    Text(
        text = employeeName,
        fontSize = 10.sp,
        modifier = Modifier
            .fillMaxWidth()
            .padding(1.5.dp, .5.dp, 1.5.dp, .5.dp)
            .clip(RoundedCornerShape(6.dp))
            .background(backgroundColor)
            .padding(2.dp, 0.dp, 2.dp, 0.dp),
        maxLines = 1,
        color = textColor,
        overflow = TextOverflow.Ellipsis
    )
}